export default {
  name: 'Simple Presentation',
  preview: 'https://cdn.affine.pro/templates/cover/simple-presentation.png',
  type: 'template',
  assets: {
    '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=':
      'https://cdn.affine.pro/templates/assets/5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=.png',
    'pgHqDtH06Wy-gIdECYBTRTPiCNMOiUkJq36uw1R14KI=':
      'https://cdn.affine.pro/templates/assets/pgHqDtH06Wy-gIdECYBTRTPiCNMOiUkJq36uw1R14KI=.png',
  },
  content: {
    type: 'page',
    meta: {
      id: 'page:home',
      title: '',
      createDate: 1702626169413,
      tags: [],
    },
    blocks: {
      type: 'block',
      id: 'block:5M7_O-ENjC',
      flavour: 'affine:page',
      props: {
        title: {
          '$blocksuite:internal:text$': true,
          delta: [],
        },
      },
      children: [
        {
          type: 'block',
          id: 'block:gvbTCw9AJV',
          flavour: 'affine:surface',
          props: {
            elements: {
              anGw5ND6Ay: {
                type: 'text',
                xywh: '[2738.520625788885,405.8804823909652,257.7919921875,96]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Agenda',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 64,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'anGw5ND6Ay',
                index: 'a2',
                seed: 278606533,
              },
              '7ZrVZsuv_0': {
                type: 'text',
                xywh: '[2738.520625788885,553.5932352169066,181,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Topic title 1',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 32,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: '7ZrVZsuv_0',
                index: 'a3',
                seed: 895600276,
              },
              '04nlt8cC-k': {
                type: 'text',
                xywh: '[2738.520625788885,652.8059880428477,188,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Topic title 2',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 32,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: '04nlt8cC-k',
                index: 'a4',
                seed: 48829006,
              },
              ZicYGultI8: {
                type: 'text',
                xywh: '[2738.520625788885,752.5187408687893,188,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Topic title 3',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 32,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'ZicYGultI8',
                index: 'a5',
                seed: 1651003819,
              },
              XxdgUwjnuH: {
                type: 'text',
                xywh: '[2738.520625788885,852.231493694731,190,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Topic title 4',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 32,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'XxdgUwjnuH',
                index: 'a6',
                seed: 826670243,
              },
              hmGvWUmUJk: {
                type: 'shape',
                xywh: '[3547.8003020290953,281.8464651790168,678.3234111544948,896.0658300980467]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-green',
                strokeWidth: 4,
                strokeColor: '--affine-palette-transparent',
                strokeStyle: 'solid',
                roughness: 1.4,
                id: 'hmGvWUmUJk',
                index: 'a7',
                seed: 1588121115,
                color: '--affine-palette-line-black',
              },
              '0iquyxCZsy': {
                type: 'text',
                xywh: '[2738.520625788885,951.9442465206721,190,48]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Topic title 5',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 32,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: '0iquyxCZsy',
                index: 'a8',
                seed: 1545891687,
              },
              Wr8iYwOCpe: {
                type: 'text',
                xywh: '[1277.2433527805765,636.8059880428477,782.2318725585938,123]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Presentation Title',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 88,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'Wr8iYwOCpe',
                index: 'aB',
                seed: 245835463,
              },
              JgPsTHrJ2v: {
                type: 'text',
                xywh: '[1625.1593073704203,772.5187408687893,86.39996337890625,51]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Date',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 36,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'JgPsTHrJ2v',
                index: 'aC',
                seed: 129807760,
              },
              pvDlwOXu1N: {
                type: 'shape',
                xywh: '[890.9482679473808,1345.1034743481873,1600.246276700244,385.33721480494546]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0,
                filled: true,
                fillColor: '--affine-palette-shape-green',
                strokeWidth: 4,
                strokeColor: '--affine-palette-line-yellow',
                strokeStyle: 'none',
                roughness: 1.4,
                id: 'pvDlwOXu1N',
                index: 'aD',
                seed: 1007621226,
                color: '--affine-palette-line-black',
              },
              S2QgZLscgY: {
                type: 'text',
                xywh: '[1411.3914746568778,1458.088060875463,559.35986328125,89]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Feature with Title',
                    },
                  ],
                },
                color: '--affine-palette-line-white',
                fontSize: 64,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'S2QgZLscgY',
                index: 'aE',
                seed: 788901929,
              },
              SSO038Yswg: {
                type: 'text',
                xywh: '[1416.9315137193778,1551.3277050824836,548.27978515625,51]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Breif description or statement',
                    },
                  ],
                },
                color: '--affine-palette-line-white',
                fontSize: 36,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: 'SSO038Yswg',
                index: 'aF',
                seed: 393504520,
              },
              ANV5lQmbS2: {
                type: 'shape',
                xywh: '[2798.6230651785054,1592.8860273404648,581.8980090418504,509.7329517289122]',
                rotate: 0,
                shapeType: 'rect',
                shapeStyle: 'General',
                radius: 0.1,
                filled: true,
                fillColor: '--affine-palette-shape-green',
                strokeWidth: 4,
                strokeColor: '--affine-palette-transparent',
                strokeStyle: 'solid',
                roughness: 1.4,
                id: 'ANV5lQmbS2',
                index: 'aG',
                seed: 865461783,
                color: '--affine-palette-line-black',
              },
              '8TR3u4185Z': {
                type: 'text',
                xywh: '[3172.4572803200454,1451.088060875463,511,96]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert: 'Image and Text',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 64,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '600',
                fontStyle: 'normal',
                textAlign: 'left',
                id: '8TR3u4185Z',
                index: 'aI',
                seed: 1880510633,
              },
              'xaPn_c0-hB': {
                type: 'text',
                xywh: '[3489.723459949698,1623.752503204921,612.9704705443019,448]',
                rotate: 0,
                text: {
                  'affine:surface:text': true,
                  delta: [
                    {
                      insert:
                        'Brief Description or statement.\n\nHow are you, your team, and your offering suited to win in the market you are entering? \n\nInclude images, schematics, or a prototype here.',
                    },
                  ],
                },
                color: '--affine-palette-line-black',
                fontSize: 40,
                fontFamily: 'blocksuite:surface:Poppins',
                fontWeight: '400',
                fontStyle: 'normal',
                textAlign: 'center',
                id: 'xaPn_c0-hB',
                index: 'aJ',
                seed: 1696426829,
                hasMaxWidth: true,
              },
            },
          },
          children: [
            {
              type: 'block',
              id: 'block:vkuAUgTQYP',
              flavour: 'affine:frame',
              props: {
                title: {
                  '$blocksuite:internal:text$': true,
                  delta: [
                    {
                      insert: 'Agenda',
                    },
                  ],
                },
                background: '--affine-tag-green',
                xywh: '[2627.9572803200454,279.8503453796615,1600,900]',
                index: 'a0',
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:-9dli-9Q3W',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=',
                width: 0,
                height: 0,
                index: 'a9',
                xywh: '[3796.2086952218488,639.126067843546,181.50662476898833,181.50662476898833]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:Nvmn6S0HbS',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=',
                width: 0,
                height: 0,
                index: 'aA',
                xywh: '[3796.2086952218488,639.126067843546,181.50662476898833,181.50662476898833]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:7iV8gMzNVt',
              flavour: 'affine:frame',
              props: {
                title: {
                  '$blocksuite:internal:text$': true,
                  delta: [
                    {
                      insert: 'Frame 2',
                    },
                  ],
                },
                background: '--affine-tag-green',
                xywh: '[883.5257171184523,277.91229527706355,1600,900]',
                index: 'a1',
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:fhhj54I3W4',
              flavour: 'affine:frame',
              props: {
                title: {
                  '$blocksuite:internal:text$': true,
                  delta: [
                    {
                      insert: 'Frame 3',
                    },
                  ],
                },
                background: '--affine-tag-green',
                xywh: '[891.1650417577732,1345.320399376866,1600,900]',
                index: 'a2',
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:7UDYuV_ug3',
              flavour: 'affine:frame',
              props: {
                title: {
                  '$blocksuite:internal:text$': true,
                  delta: [
                    {
                      insert: 'Frame 4',
                    },
                  ],
                },
                background: '--affine-tag-green',
                xywh: '[2627.9572803200454,1345.1034743481873,1600,900]',
                index: 'a3',
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:FEcs75x79Z',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: '5hrUa6iRv8QEHQ4GukdlEKAJCfsLfn_SO7e1R7-kLbw=',
                width: 0,
                height: 0,
                index: 'aH',
                xywh: '[2998.818757314936,1756.9991908204267,181.50662476898833,181.50662476898833]',
                rotate: 0,
                size: -1,
              },
              children: [],
            },
            {
              type: 'block',
              id: 'block:HeHDqEBke8',
              flavour: 'affine:image',
              props: {
                caption: '',
                sourceId: 'pgHqDtH06Wy-gIdECYBTRTPiCNMOiUkJq36uw1R14KI=',
                width: 538,
                height: 538,
                index: 'aHV',
                xywh: '[1597.7600608555263,1885.1298123209674,186.62269088395297,186.62269088395317]',
                rotate: 0,
                size: 8156,
              },
              children: [],
            },
          ],
        },
      ],
    },
  },
};
